import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import './index.css';
import { installRemoteErrorCapture } from './utils/remoteLog';

// V8.3.2: registro remoto de erros (Gerenciador → Telemetria de Erros e api/claude.php)
installRemoteErrorCapture();

// Migração transparente de autenticação de HTTPS para HTTP
try {
  const urlParams = new URLSearchParams(window.location.search);
  const migrated = urlParams.get('migrated_auth');
  if (migrated) {
    const data = JSON.parse(atob(decodeURIComponent(migrated)));
    if (data && data.t && data.u) {
      localStorage.setItem('nexus_auth_token', data.t);
      localStorage.setItem('nexus_auth_user', JSON.stringify(data.u));
    }
    urlParams.delete('migrated_auth');
    const newSearch = urlParams.toString() ? `?${urlParams.toString()}` : '';
    window.history.replaceState({}, '', window.location.pathname + newSearch + window.location.hash);
  }
} catch (e) {
  console.warn('Auth migration check error:', e);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

// Registro de Service Worker para Cache Offline PWA e Capas
if (typeof window !== 'undefined' && 'serviceWorker' in navigator && (import.meta as any).env?.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.log('[OpenTV SW] Registrado com sucesso:', reg.scope);
        // Força checagem imediata de nova versão do sw.js a cada inicialização
        reg.update().catch(() => {});
      })
      .catch((err) => {
        console.warn('[OpenTV SW] Falha ao registrar:', err);
      });
  });
}

